<template>
  <div>
    <div class="container">
      <Transition>
        <section v-if="showMessage">
          <div class="mt-3 mb-3">
            <b-message
              :title="message.title"
              :type="message.type"
              :closable="false"
              has-icon
            >
              Codul <strong>{{ message.code }}</strong> {{ message.status }}
            </b-message>
          </div>
        </section>
      </Transition>

      <Transition>
        <div v-if="loading">
          <section class="section is-large">
            <progress class="progress is-large is-primary" max="100" />
          </section>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import RestResource from "../services/one-api.js";
export default {
  methods: {
    showError() {
      this.message.title = "Cod incorect!";
      this.message.type = "is-danger";
      this.message.status = "este incorect!";
      this.displayMessage();
    },

    showSuccess() {
      this.message.title = "Cod corect!";
      this.message.type = "is-success";
      this.message.status = "este corect!";
      this.displayMessage();
    },

    showWarning(message) {
      this.message.title = "Atentie!";
      this.message.type = "is-warning";
      this.message.status = "nu poate fi verificat! (" + message + ")";
      this.displayMessage();
    },

    displayMessage(message, type) {
      this.message.code = this.$route.params.sn;

      this.showMessage = true;
    },

    async validateCertificateSn() {
      let restData = null;

      try {
        restData = await this.restService.workflow(
          "DroneUtils",
          "validareCodCertificat",
          { cod_certificat: this.$route.params.sn }
        );
      } catch (error) {
        //console.log("err " + error);

        this.showError(error);
        return null;
      }
      console.log(restData);

      this.showSuccess();
    },
  },

  async mounted() {
    this.restService = RestResource(
      this.axios,
      "5a6c1041-7843-42cd-8a07-a0d397ddcb73"
    );

    await this.validateCertificateSn();

    this.loading = false;
  },
  data() {
    return {
      restService: null,
      loading: true,
      message: {},
      showMessage: false,
    };
  },
};
</script>
